<template>
  <div>
    <OrderedItemBaseCard
      :name="item.item_name"
      :name-color="!item.isOnMenu ? '#E0961E' : null"
      :original-price="item.total"
      :current-price="item.total"
      :test-name-list="getEditOrderTestNameList(item)"
      :markup-price="item.markupPrice"
      :customized-test-name-changed="item.customizedName && item.orignalCustomizedName !== item.customizedName"
      :is-show-markup-price="isShowMarkupPrice"
      :is-show-edit-markup="false"
      :show-original-price="paymentMethod !== 'wellProz'"
      @clear="removeEditOrderItem(item)"
    />
    <Alert type="warning" v-if="!item.isOnMenu">
      <div class="flex items-center px-4 py-3">
        <span class="material-icons pr-3 error-icon-size">error</span>
        <p class="warning-text">
        {{ item.item_name }} is discontinued from the menu, you cannot add it back if removed from the cart.
        </p>
      </div>
    </Alert>
    <OrderTestDialog 
      v-if="isShowRemoveOldProductsDialog"
      title="Warning!"
      :is-show-dialog="isShowRemoveOldProductsDialog"
      @close="isShowRemoveOldProductsDialog = false"
    >
      <p>{{ item.item_name }} is no longer available.</p>
      <p class="mt-4">
        If you delete it, you will no longer to order it in the future.
      </p>
      <p>If you keep it, we will still order it for you.</p> 
      <template #buttons>
        <LoginButton @click="isShowRemoveOldProductsDialog = false" type="primary" class="ml-2.5 w-36">
          Keep
        </LoginButton>
        <LoginButton @click="removeItemNotOnMenu(item)" class="w-36" plain type="error">
          Delete
        </LoginButton>
      </template>     
    </OrderTestDialog>
  </div>
</template>

<script>
import OrderedItemBaseCard from "./OrderedItemBaseCard.vue";
import Alert from "./Alert.vue";
import OrderTestDialog from "./OrderTestDialog.vue";
import LoginButton from "@/views/login/components/LoginButton.vue";
import { mapState, mapGetters } from "vuex";
import _ from "lodash";

export default {
  components: {
    OrderedItemBaseCard,
    Alert,
    OrderTestDialog,
    LoginButton
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState("orderTest/order", ["paymentMethod"]),
    ...mapGetters("orderTest/order", ["isMarkupEligible"]),
    isShowMarkupPrice() {
      let { markupVersion } = this.item; 
      return this.isMarkupEligible && ( !_.isNil(markupVersion) || markupVersion === 0);
    }
  },
  data() {
    return {
      isShowRemoveOldProductsDialog: false
    }
  },
  methods: {
    getEditOrderTestNameList(item) {
      let testNameList = [];
      if (item.category === "xChooseY") {
        let xChooseYDetails = [];
        let { x_choose_y_List, supplement_x_choose_y_List } = item;
        if (x_choose_y_List && x_choose_y_List[0]) {
          let details = x_choose_y_List[0].x_choose_y_detail_list;
          xChooseYDetails = details ? xChooseYDetails.concat(details) : xChooseYDetails;
        }
        if (supplement_x_choose_y_List && supplement_x_choose_y_List[0]) {
          let supplementDetails = supplement_x_choose_y_List[0].x_choose_y_detail_list;
          xChooseYDetails = supplementDetails ? xChooseYDetails.concat(supplementDetails) : xChooseYDetails;
        }
        testNameList = xChooseYDetails.map(item => item.item_name);
      }
      if (["shortcut", "seasonalPromo"].includes(item.category)) {
        testNameList = item.contents.map(item => item.item_name);
      }
      return testNameList;
    },

    removeEditOrderItem(item) {
      if (!item.isOnMenu) {
        this.isShowRemoveOldProductsDialog = true;
        return;
      }
      // remove item in edit order original item
      this.$store.dispatch("orderTest/orderDraft/removeEditOrderItem", item);
      this.$emit("removeItem", item);
    },

    removeItemNotOnMenu(item) {
      this.$store.dispatch("orderTest/orderDraft/removeEditOrderItem", item);
      this.$emit("removeItem", item);
      this.isShowRemoveOldProductsDialog = false;
    }
  }
}
</script>

<style scoped>
.error-icon-size {
  font-size: 18px;
}
.warning-text {
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.4px;
}
</style>